export abstract class UserRoles {
    public static Admin: string = "Admin";
    public static Tecnico: string = "Tecnico";
    public static Consulente: string = "Consulente";
    public static TitolareAgenzia: string = "Titolare Agenzia";
    public static ResponsabileAgenzia: string = "Responsabile Agenzia";
    public static TeamLeader: string = "Team Leader";
}